import { api } from '../api';
import { v4 as uuidv4 } from 'uuid';


function generationPassword() {
   const base = uuidv4();
   return base.split('-')[0]
};

export async function getUsersSystem() {
    try {
        const { data } = await api.get(`/user`)
        return data;
    }
    catch (error) {
        return false;
    }
};

export async function getUsers() {
    try {
        const { data } = await api.get(`/user?tipo=U`)
        return data;
    }
    catch (error) {
        return false;
    }
};

export async function getGroupsUser(userID) {
    if (!userID) return
    try {
        const { data } = await api.get(`/user/${userID}/group`)
        return data;
    }
    catch (error) {
        return false;
    }
};

export async function createUser(user) {
    const password = generationPassword()
    try {
        const { data } = await api.post(`/user?name=${user?.name}&username=${user?.username.replace(" ", "")}&email=${user?.email}&phone=${user?.phone}&tipo=U&password=${password}`)
        if (data?.status_code === 201) {
            return {
                status_code: 201,
                id: data.data?.user_id,
                username: user?.username,
                password: password,
                duplicateUser: false
            }
        }
    }
    catch (error) {
        const { data: message } = error?.response;
        if (message) {
            return {
                status_code: 403,
                id: message?.usuario,
                username: user?.username,
                password: password,
                duplicateUser: true
            }
        }
        return {
            status_code: 500,
            message: 'Erro ao Criar o Usuário '
        }
    }
};

export async function updateUser(user) {
    try {
        const { data } = await api.put(`/user/${user?.id}?user_id=${user?.id}&name=${user?.name}&username=${user?.username.replace(" ", "")}&email=${user?.email}&phone=${user?.phone}&tipo=U`)
        if (data?.status_code === 200) {
            return {
                status_code: 200,
            }
        }
    }
    catch (error) {
        return {
            status_code: 500,
            message: 'Erro ao alterar usuário '
        }
    }
};

export async function reuseUser(user) {
    try {
        const { data } = await api.post(`/user-reuse?usuario_id=${user.id}&permissao=${user.accessLevel}&group_id=${user.groups}`)
        if (data === 200) {
            return {
                status_code: 200,
                message: 'Usuário criado com sucesso !'
            }
        }
    }
    catch (error) {
        const { data: message } = error?.response;
        if (message) {
            return {
                status_code: 403,
                message: message?.message
            }
        }
        return {
            status_code: 500,
            message: 'Erro ao cadastrar usuário '
        }
    }
};

export async function infoReuseUser(userID) {
    try {
        const { data: { usuario } } = await api.post(`/info-user-reuse?usuario_id=${userID}`)
        if (usuario) {
            return {
                status_code: 200,
                user: usuario
            };
        }
    }
    catch (error) {
        const { data: message } = error?.response;
        if (message) {
            return {
                status_code: 403,
                message: (message.usuario)
                    ? message.usuario
                    : message.message
            }
        }
        return {
            status_code: 500,
            message: 'Erro ao cadastrar usuário '
        }
    }
};

export async function generateNewPassword(user) {
    const password = generationPassword()
    try {
        const { data } = await api.put(`/user/${user?.id}?user_id=${user?.id}&password=${password}`)
        if (data?.status_code === 200) {
            return {
                status_code: 200,
                id: user?.user_id,
                username: user?.username,
                password: password
            }
        }
    }
    catch (error) {
        return {
            status_code: 500,
            message: 'Erro ao gerar nova senha '
        }
    }
};

export async function resetPassword(password) {
    try {
        const { data } = await api.post(`/user/alter-password?current_password=${encodeURIComponent(password.current)}&new_password=${encodeURIComponent(password.new)}&confirm_password=${encodeURIComponent(password.confirm)}`)
        return {
            status_code: 200,
            message: data?.message
        }
    }
    catch (error) {
        const { data: message } = error?.response;
        if (message) {
            return {
                status_code: 400,
                message: message?.message
            }
        }
        return {
            status_code: 500,
            message: 'Erro ao Redefinir Senha '
        }
    }
};

export async function disableUser(userID) {
    try {
        const { data } = await api.delete(`/user/${userID}`)
        if (data?.status_code === 200) {
            return {
                status_code: 200,
            }
        }
    }
    catch (error) {
        return {
            status_code: 500,
            message: 'Erro ao Desabilitar Usuário '
        }
    }
};